import './divider.css';

export default function Divider() {
    return <div className='divider' />;
}
